import React from 'react';
import moment from 'moment';
import keys from 'lodash/keys';
import PropTypes from 'prop-types';
import values from 'lodash/values';
import { humanize } from '../../shared/helpers/index';

const getNormalizedResponse = (selectedValues, items) =>
  selectedValues
    .map(s => values(s)[0])
    .filter(
      item =>
        ![items, 'managed', 'compulsory_managed'].includes(item) &&
        item !== null,
    );

const formatDate = date => {
  const momentDate = moment(date, 'DD-MM-YYYY');
  return momentDate.isValid() ? [momentDate.format('MM/DD/YYYY')] : [];
};

const modifiers = {
  managed_marketplace: (selectedValues, items) =>
    getNormalizedResponse(selectedValues, items),
  deadline: date => formatDate(date),
};

export const OverviewStepItem = ({
  info,
  status,
  onboardingStepsInfo,
  question,
  currentStep,
  overviewInfoIndex,
  generalIndex,
  index,
  handleGoToAnswer,
  dashboardClass,
}) => {
  const questionIndex = onboardingStepsInfo.findIndex(
    q => q.key === question.key,
  );

  const deadlineQuestion =
    onboardingStepsInfo.find(q => q.key === 'deadline') || {};

  const item = deadlineQuestion.status === 'empty' ? 'marketplace' : '';

  const { selectedValue } = onboardingStepsInfo[questionIndex];

  const modifiersKeys = keys(modifiers);

  const response = !modifiersKeys.includes(question.key)
    ? selectedValue
    : modifiers[question.key](selectedValue, item);

  let answer = '';
  if (response.length > 1) {
    answer = `${response.length}_answers_selected`;
  } else if (response.length === 1) {
    [answer] = response;
  }

  const answeredClass = answer ? `--filled${dashboardClass}` : '';

  const isEnabledQuestion =
    info.key === currentStep ||
    status === 'done' ||
    answer ||
    overviewInfoIndex > generalIndex;

  let humanizedAnswer = '';
  if (answer) {
    humanizedAnswer = humanize(answer);
  } else if (!isEnabledQuestion) {
    humanizedAnswer = 'Incomplete';
  }

  return (
    <ol key={index} className="overview-step__question">
      <li
        className={`overview-step__question-name
                    ${!isEnabledQuestion &&
                      'overview-step__question-name--disabled'}
                    overview-step__question-name${answeredClass}`}
      >
        {question.name}
      </li>
      <li
        onClick={
          isEnabledQuestion
            ? () => handleGoToAnswer(info.key, question.key)
            : () => {}
        }
        className={`overview-step__question-answer
                            overview-step__question-answer${answeredClass}
                            ${!isEnabledQuestion &&
                              `overview-step__question-answer--disabled${answeredClass}`}
                            `}
      >
        {humanizedAnswer}
      </li>
    </ol>
  );
};

OverviewStepItem.propTypes = {
  info: PropTypes.object,
  status: PropTypes.string,
  onboardingStepsInfo: PropTypes.array,
  question: PropTypes.object,
  currentStep: PropTypes.string,
  handleGoToAnswer: PropTypes.func,
  overviewInfoIndex: PropTypes.number,
  generalIndex: PropTypes.number,
  index: PropTypes.number,
  dashboardClass: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/OverviewStepItem/OverviewStepItem.js